<template>
  <div>
    <section class="pricing py-5">
      <div>
        <h1 style="color:#fff; font-weight:bold" class="text-center">
          Orbis Pricing
        </h1>
      </div>
      <div class="container py-5">
        <div class="row justify-content-center">
          <!-- Free Tier -->
          <div class="col-lg-4" style="margin:20px;" data-aos="flip-left">
            <div class="card mb-5 mb-lg-0 rounded-0">
              <div class="card-body">
                <h5 class="card-title text-muted text-uppercase text-center">
                  Free
                </h5>
                <h6 class="card-price text-center">
                  $0<span class="period">/month</span>
                </h6>
                <hr />
                <ul class="fa-ul">
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>
                    Unlimited Jobs
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>1
                    Users Per Job
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>10 GB
                    Storage
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>Map
                    Annotation
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>Photos
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Dashboard
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>
                    PDF Exports
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Offline Support
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>GPS
                    Data Visualization
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Invoicing
                  </li>
                  <li class="text-muted">
                    <span class="fa-li"><i class="fa fa-times"></i></span>Chat
                    and email Support
                  </li>
                  <li class="text-muted">
                    <span class="fa-li"><i class="fa fa-times"></i></span>Phone
                    Support
                  </li>
                  <li class="text-muted">
                    <span class="fa-li"><i class="fa fa-times"></i></span
                    >Customer Success Manager
                  </li>
                  <li class="text-muted">
                    <span class="fa-li"><i class="fa fa-times"></i></span
                    >Training
                  </li>
                  <li class="text-muted">
                    <span class="fa-li"><i class="fa fa-times"></i></span>Custom
                    Data Support
                  </li>
                  <li class="text-muted">
                    <span class="fa-li"><i class="fa fa-times"></i></span>Data
                    Import
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Pro Tier -->
          <div class="col-lg-4" style="margin:20px" data-aos="flip-right">
            <div class="card rounded-0">
              <div
                class="card-body"
                style="color:#fff; background-color:#00a8ff"
              >
                <h5 class="card-title text-uppercase text-center">
                  Pro
                </h5>
                <h6 class="card-price text-center" style="font-weight:bold">
                  $25<span class="period">/month</span>
                </h6>
                <hr />
                <ul class="fa-ul">
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Unlimited Jobs
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Unlimited Users Per Job
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>100 GB
                    Storage
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>Map
                    Annotation
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>Photos
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Dashboard
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>
                    PDF Exports
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Offline Support
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>GPS
                    Data Visualization
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Invoicing
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>Chat
                    and email Support
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>Phone
                    Support
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Customer Success Manager
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span
                    >Training
                  </li>

                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>Custom
                    Data Support
                  </li>
                  <li data-aos="flip-down">
                    <span class="fa-li"><i class="fa fa-check"></i></span>Data
                    Import
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      Feature: [[]]
    };
  }
};
</script>

<style lang="scss" scoped>
section.pricing {
  background: #272727;
  background: linear-gradient(to right, #272727, #0d0d0d);
}

.pricing .card {
  border: none;
  border-radius: 1rem;
  transition: all 0.2s;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.pricing hr {
  margin: 1.5rem 0;
}

.pricing .card-title {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  letter-spacing: 0.1rem;
  font-weight: bold;
}

.pricing .card-price {
  font-size: 3rem;
  margin: 0;
}

.pricing .card-price .period {
  font-size: 0.8rem;
}

.pricing ul li {
  margin-bottom: 1rem;
}

.pricing .text-muted {
  opacity: 0.7;
}

.pricing .btn {
  font-size: 80%;
  border-radius: 5rem;
  letter-spacing: 0.1rem;
  font-weight: bold;
  padding: 1rem;
  opacity: 0.7;
  transition: all 0.2s;
}

/* Hover Effects on Card */

@media (min-width: 992px) {
  .pricing .card:hover {
    margin-top: -0.25rem;
    margin-bottom: 0.25rem;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
  }
  .pricing .card:hover .btn {
    opacity: 1;
  }
}
</style>
